module.exports = __webpack_public_path__ + "img/大雨.46e1d8ae.png";